<!--
* @Description: 值班表 详情
* @Author: PF
* @Date: 2023-03-08 14:26:07.84
 * @LastEditors: PF
 * @LastEditTime: 2025-05-27 10:09:24
-->
<template>
  <div>
    <el-dialog class="w900 h700" :model-value="openDetail" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Document />
          </el-icon>
          <span class="header-title">详情</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDetail', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-descriptions :column="4" border>
        <el-descriptions-item label="值班日期" label-align="right" align="left" width="140px" span="2">{{ruleForm.zbrq}}</el-descriptions-item>
        <el-descriptions-item label="值班类别" label-align="right" align="left" width="140px" span="2">{{ruleForm.zblbmc}}</el-descriptions-item>
        <el-descriptions-item label="值班内容名称" label-align="right" align="left" span="2">{{ruleForm.zbnrmc}}</el-descriptions-item>
        <el-descriptions-item label="值班人（手机）" label-align="right" align="left" span="2">
          <span class="mr5">{{ ruleForm.zbryxm }}</span>
          <span>{{ ruleForm.yddh }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="职务" label-align="right" align="left" span="2">{{ruleForm.zwmc}}</el-descriptions-item>
        <el-descriptions-item label="值班时段" label-align="right" align="left" span="2">
          <span v-for="(item, index) in zbsdData" :key="index">
            <span v-if="ruleForm.zbsd === item.value">{{item.name}}</span>
          </span>
        </el-descriptions-item>
        <el-descriptions-item label="值班时间" label-align="right" align="left" span="2">
          {{ ruleForm.zbkssj }}
          <span v-if="ruleForm.zbkssj && ruleForm.zbjssj">-</span>
          {{ ruleForm.zbjssj }}
        </el-descriptions-item>
        <el-descriptions-item label="值班日志状况" label-align="right" align="left" span="2">
          <span v-for="(item, index) in zbrzzkData.listZhuangTai" :key="index">
            <span v-if="ruleForm.zbrbzk === item.value">{{item.name}}</span>
          </span>
        </el-descriptions-item>
        <el-descriptions-item label="值班状态" label-align="right" align="left" span="2">
          <span v-for="(item, index) in zbrbzkData.listZhuangTai" :key="index">
            <span v-if="ruleForm.zbzt === item.value">{{item.name}}</span>
          </span>
        </el-descriptions-item>
        <el-descriptions-item label="值班位置" label-align="right" align="left" span="2">{{ruleForm.zbwz}}</el-descriptions-item>
        <el-descriptions-item label="存在问题" label-align="right" align="left" span="4">{{ruleForm.czwt}}</el-descriptions-item>
        <el-descriptions-item label="处理结果" label-align="right" align="left" span="4">{{ruleForm.cljg}}</el-descriptions-item>
      </el-descriptions>
      <el-divider v-if="ruleForm.zbnrs.length">值班内容</el-divider>
      <el-descriptions :column="4" border>
        <el-descriptions-item v-for="(item,index) in ruleForm.zbnrs" :key="index" :label="item.mbzdmc" label-align="right" align="left" width="140px" span="4">
          <span v-if="zbrzmblxData.wb === item.lx">{{ item.nr }}</span>
          <div v-else style="display: flex;flex-direction: column;">
            <span v-for="(val,v) in item.xxnrs" :key="v">
              <span v-if="val.sfmrz">{{ val.xxnr }}</span>
            </span>
          </div>
        </el-descriptions-item>
      </el-descriptions>
      <!-- <table class="mt10" width="100%" border="1" cellpadding="0" cellspacing="0" bordercolor="#CCCCCC">
        <tr v-for="(item,index) in ruleForm.zbnrs" :key="index">
          <td bgcolor="#f4f4f5" class="pl10 pr10 pt5 pb5 w200" style="text-align: right;">{{item.mbzdmc}}</td>
          <td style="text-align: left;padding: 5px 10px;">
            <span v-if="zbrzmblxData.wb === item.lx">{{ item.nr }}</span>
            <div v-else style="display: flex;flex-direction: column;">
              <span v-for="(val,v) in item.xxnrs" :key="v">
                <span v-if="val.sfmrz">{{ val.xxnr }}</span>
              </span>
            </div>
          </td>
        </tr>
      </table> -->
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="info" @click="closeWindow('openDetail', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import { loadData, loadSelect, closeWindow } from '@/api/common.js'

const props = defineProps({
  openDetail: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openDetail'])
const ruleForm = ref({zbnrs: []})

// 加载 值班类别 下拉框
const zblbData = ref([])
// 加载 值班内容 下拉框
const zbnrData = ref([])
// 加载 值班时段 下拉框
const zbsdData = ref([])
// 加载 值班状况 下拉框
const zbrbzkData = ref({ listZhuangTai: [] })
// 加载 值班日志状况 下拉框
const zbrzzkData = ref({ listZhuangTai: [] })
// 加载 值班日志模板类型 下拉框
const zbrzmblxData = ref({ listZhuangTai: [] })
watch(
  () => props.openDetail,
  () => {
    if (props.openDetail) {
      loadSelect({ url: '/api/v2/bangong/zhibanleibie/list', data: zblbData, order: 'sx', sort: 'asc' })
      loadSelect({ url: '/api/v2/bangong/zhibanneirong/list', data: zbnrData, parms: { zt: 2 }, order: 'zbnrmc', sort: 'asc' })
      loadSelect({ url: '/api/v2/bangong/zhibanrizhimuban/zhibanrizhileixing', data: zbrzmblxData })
      loadSelect({ url: '/api/v2/bangong/zhibanneirong/zhibanshiduan', data: zbsdData })
      loadSelect({ url: '/api/v2/bangong/zhibanrenyuanjilu/zhibanzhuangtai', data: zbrbzkData })
      loadSelect({ url: '/api/v2/bangong/zhibanrenyuanjilu/zhibanrizhizhuangtai', data: zbrzzkData })
      loadData({
        url: '/api/v2/bangong/zhibanrenyuanrizhijilu/zhibanrizhi/' + props.row.id,
        ruleForm
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
